import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './router';

import { setSentry } from '@meteor/sentry';
import './reset.css';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://b98407be694ea5671d6986a251ce83a0@o4508733999611904.ingest.de.sentry.io/4508910113914960',

    integrations: [Sentry.browserTracingIntegration()],

    tracesSampleRate: 1.0,

    tracePropagationTargets: [
      'localhost',
      'wsx',
      // All metorial.com subdomains
      /^https:\/\/.*\.metorial\.com/,
      // All metorial-staging.click subdomains
      /^https:\/\/.*\.metorial-staging\.click/,
      // All metorial.net subdomains
      /^https:\/\/.*\.metorial\.net/
    ],

    environment: process.env.METORIAL_ENV || process.env.VITE_METORIAL_ENV,

    ignoreErrors: [
      'not found',
      'not be found',
      'internal server error',
      'bad_request',
      'not authorized',
      'Unable to reach server'
    ]
  });

  setSentry(Sentry as any);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
